import { render } from "./ConsignmentsTable.vue?vue&type=template&id=6944456c"
import script from "./ConsignmentsTable.vue?vue&type=script&lang=ts"
export * from "./ConsignmentsTable.vue?vue&type=script&lang=ts"

import "./ConsignmentsTable.vue?vue&type=style&index=0&id=6944456c&lang=scss"
script.render = render

export default script